import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { LoadingOverlay } from '../../../abelcommon/components/LoadingOverlay';
import { MiningAccount, loadBalancerAPI } from '../../../api/load-balancer';
import { useTranslation } from 'react-i18next';

export const DeleteAccountModal = ({
  miningAccount,
  onClose,
  onSuccess,
  onError,
}: {
  miningAccount: MiningAccount;
  onClose: () => void;
  onSuccess: (message: string) => void;
  onError: (message: string) => void;
}) => {
  const { mutate: mutateDeleteMiningAccount, isLoading } = loadBalancerAPI.hookWrapperMutation.useDeleteMiningAccount();
  const { t } = useTranslation();
  const handleDeleteAccount = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isLoading) return;

    mutateDeleteMiningAccount(miningAccount.id, {
      onSuccess: () => {
        onSuccess(t('deleteAccountModal.deleteAccountSuccessfully'));
        onClose();
      },
      onError: (error) => {
        onError(error.message);
      },
    });
  };

  return (
    <Dialog
      open
      onClose={onClose}
      PaperProps={{
        component: 'form',
        onSubmit: handleDeleteAccount,
      }}
    >
      <DialogTitle>{t('deleteAccountModal.deleteAccount')}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers sx={{ py: 4 }}>
        <Alert severity="warning" sx={{ backgroundColor: 'transparent', fontSize: '0.875rem', p: 0 }}>
          {t('deleteAccountModal.wantToDelete')} "{miningAccount.name}" {t('deleteAccountModal.accountLowCase')}? <br />
          <Box sx={{ mt: 1 }}>{t('deleteAccountModal.disableDeleteAction')}</Box>
        </Alert>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} size="small" color="info">
          {t('deleteAccountModal.cancel')}
        </Button>
        <Button type="submit" variant="contained" size="small" disabled={isLoading}>
          {t('deleteAccountModal.confirm')}
        </Button>
      </DialogActions>
      {isLoading && <LoadingOverlay />}
    </Dialog>
  );
};
